import React, { type FC } from 'react'

import { useIntl } from 'react-intl'

import { Select } from 'mailup-web-components'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import { changeCriterionCallback } from 'Pages/RecipientsList/recoil/callbacks/filters'
import { criterionOptinDateState } from 'Pages/RecipientsList/recoil/state/filters'

interface InputChannelProps {
  index: number
}

const InputChannel: FC<InputChannelProps> = ({ index }) => {
  const intl = useIntl()

  const { channel } = useRecoilValue(criterionOptinDateState(index))

  const changeCriterion = useRecoilCallback(changeCriterionCallback, [])

  const options = [
    {
      value: 'email',
      label: intl.formatMessage({ id: 'Load.RecipientsList.ChannelEmail' }),
    },
    {
      value: 'sms',
      label: intl.formatMessage({ id: 'Load.RecipientsList.ChannelSMS' }),
    },
  ]

  const handleChange = (v: 'email' | 'sms'): void => {
    void changeCriterion('channel', v, index)
  }

  return (
    <Select
      value={channel}
      onChange={handleChange}
      options={options}
      data-mu-test="select-channel"
      searchable={false}
    />
  )
}

export default InputChannel
